'use strict';

var index = require('../index-c6190cd6.js');
var ArrowDown = require('@qlik-trial/sprout/icons/ArrowDown');
var CloseIcon = require('@qlik-trial/sprout/icons/Close');
var theme_components_CheckboxIcon = require('./components/CheckboxIcon.js');
var theme_components_CheckedCheckboxIcon = require('./components/CheckedCheckboxIcon.js');
var theme_components_IndeterminateCheckboxIcon = require('./components/IndeterminateCheckboxIcon.js');
var theme_components_RadioIcon = require('./components/RadioIcon.js');
var theme_components_CheckedRadioIcon = require('./components/CheckedRadioIcon.js');
var theme_components_SortIcon = require('./components/SortIcon.js');
var variables = require('../variables-1eb6495a.js');
require('./components/IconWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var ArrowDown__default = /*#__PURE__*/_interopDefaultLegacy(ArrowDown);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);

// import CheckedSwitchIcon from './components/CheckedSwitchIcon';
const props = {
    MuiAppBar: {
        elevation: 0,
    },
    MuiButtonBase: {
        disableRipple: true,
        disableTouchRipple: true,
        focusVisibleClassName: "sprout-focus-visible",
    },
    MuiButtonGroup: {
        disableRipple: true,
    },
    MuiButton: {
        focusVisibleClassName: "sprout-focus-visible",
    },
    MuiChip: {
        deleteIcon: index.React.createElement(CloseIcon__default['default'], { size: "small" }),
    },
    // @ts-ignore
    MuiAutocomplete: {
        popupIcon: index.React.createElement(ArrowDown__default['default'], null),
        forcePopupIcon: true,
    },
    MuiOutlinedInput: {
        notched: false,
    },
    MuiSelect: {
        IconComponent: () => index.React.createElement(ArrowDown__default['default'], { size: "small" }),
        MenuProps: {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
            getContentAnchorEl: null,
        },
        variant: "outlined",
    },
    MuiInputLabel: {
        shrink: true,
    },
    MuiRadio: {
        color: "primary",
        size: "small",
        icon: index.React.createElement(theme_components_RadioIcon, null),
        checkedIcon: index.React.createElement(theme_components_CheckedRadioIcon, null),
    },
    MuiCheckbox: {
        color: "primary",
        size: "small",
        icon: index.React.createElement(theme_components_CheckboxIcon, null),
        checkedIcon: index.React.createElement(theme_components_CheckedCheckboxIcon, null),
        indeterminateIcon: index.React.createElement(theme_components_IndeterminateCheckboxIcon, null),
    },
    MuiCircularProgress: {
        thickness: 3,
        disableShrink: true,
    },
    MuiDialog: {
        fullWidth: true,
    },
    MuiDialogTitle: {
        disableTypography: true,
    },
    MuiDialogContentText: {
        variant: "body2",
    },
    MuiSwitch: {
        color: "primary",
        size: "small",
        // checkedIcon: <CheckedSwitchIcon />,
    },
    MuiTabs: {
        indicatorColor: "primary",
        textColor: "primary",
    },
    MuiToolbar: {
        disableGutters: true,
    },
    MuiTooltip: {
        arrow: true,
    },
    MuiExpansionPanelSummary: {
        expandIcon: (index.React.createElement(ArrowDown__default['default'], { size: "small", style: { color: variables.COLORS.TEXT_PRIMARY } })),
    },
    MuiTableSortLabel: {
        IconComponent: ({ className }) => index.React.createElement(theme_components_SortIcon, { className: className }),
    },
};

module.exports = props;
